export const FOLDER_CONTENT_PAGE_LIMIT = 200;
